import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import {
    BeneficiaryOTPValidate as BENE_VERIFY,
    BeneficiaryAddResendOTP as BENE_RESEND_OTP
} from 'Components/Api/NovityDMTAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Container, Grid, Paper, Button, Hidden } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useLocation } from 'react-router-dom';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const BeneficiaryVerify = () => {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const ActiveDMTName = location?.state?.ActiveDMTName;
    const BeneficiaryID = location?.state?.BeneficiaryID;
    const Mobile = location?.state?.Mobile;

    const [formObject, setFormObject] = useState({
        Mobile: Mobile,

        OTP: '',
        BeneficiaryID: BeneficiaryID,
        DMTName: ActiveDMTName
    });

    const resendOTP = async (values) => {
        values.DMTName = ActiveDMTName;
        var requestObj = JSON.stringify(values);
        setLoading(true);
        setIsError(false);
        var response = await BENE_RESEND_OTP(requestObj);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);
        setResponseMessage(data.Message);
        setSeverity('success');
        setIsError(true);
        return;
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var request = {
            BeneID: values.BeneficiaryID,
            OTP: values.OTP,
            DMTName: ActiveDMTName,
            Mobile: values.Mobile
        };

        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await BENE_VERIFY(requestObj);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);
        setResponseMessage(data.Message);
        setSeverity('success');
        setIsError(true);

        var param = {
            Mobile: values.Mobile,
            DMTName: ActiveDMTName
        };
        history.push('/NTDMT_SenderSearch', param);
    };

    const FormValidationSchema = Yup.object({
        OTP: Yup.string().required(PLEASE_PROVIDE_VALID + 'OTP'),
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                Beneficiary OTP Verify
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Sender Mobile"
                                                name="Mobile"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Sender Mobile"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="OTP"
                                                name="OTP"
                                                length={6}
                                                type="text"
                                                placeholder="OTP"
                                            />

                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="BeneficiaryID"
                                                    name="BeneficiaryID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="BeneficiaryID"
                                                />
                                            </Hidden>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Verify"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            onClick={(e) => {
                                                setFieldValue(
                                                    'isSecondSubmit',
                                                    false
                                                );
                                                handleSubmit(e);
                                            }}
                                            disabled={loading}
                                        >
                                            Verify
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>

                                    <div
                                        className={
                                            classes.SubmitWrapperWithMarginRight
                                        }
                                    >
                                        <Button
                                            title="Resend"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loading}
                                            fullWidth
                                            onClick={(e) => {
                                                resendOTP(values);
                                            }}
                                        >
                                            Resend
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            />
        </CustomContainer>
    );
};
